// removed by extract-text-webpack-plugin
module.exports = {"loader":"appLoader__loader___38V1L"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/appLoader/appLoader.scss
 ** module id = 688
 ** module chunks = 0
 **/